<template>
	<div>
		<!-- 导航栏 -->
		<nav class="navbar" :class="{ scrolled: isScrolled }">
			<div class="nav-container">
				<router-link class="logo" to="/index">
					<div class="logo-icon">知</div>
					<div class="logo-text">职业能力协同图谱系统</div>
					<span class="version-badge">V1.0</span>
				</router-link>

				<div class="nav-menu">
					<router-link :to="item.path" class="nav-link" v-for="item in menuItems" :key="item.path"
						:exact="item.exact">{{ item.name }}</router-link>
				</div>

				<div class="nav-actions">
					<!-- <UserAvatar /> -->
					<!-- 已登录状态 -->
					<div class="user-info" v-if="isLogin">
						<div class="user-header" @click="handleClick">
							<span class="user-name">{{ userData.user_name}}</span>
							<!-- <div class="ff-coins">
								<div class="ff-icon">FF</div>
								<span>{{ tokenBalance?tokenBalance:userData.user.tokenBalance}}</span>
							</div> -->
						</div>

						<div class="user-dropdown" v-if="showMenu && isLogin">
							<!-- <a href="#" class="dropdown-item" @click.prevent="handleRechare('/recharge')">充值中心</a> -->
							<div class="dropdown-divider"></div>
							<a href="#" class="dropdown-item" @click.prevent="handleLogout">退出登录</a>
						</div>
					</div>
					<!-- 未登录状态 -->
					<button class="login-btn" v-else @click="handleClick">
						登录
					</button>
				</div>
			</div>
		</nav>
	</div>
</template>

<script>
	import UserAvatar from '@/components/login/UserAvatar.vue'
	export default {
		name: 'NavigationHeader',
		components: {
			UserAvatar
		},
		props: {
			currentPage: {
				type: String,
				default: 'index'
			},
			user: {
				type: Object,
				default: null
			}
		},
		data() {
			return {
				isScrolled: false,
				showOrgBar: true,
				menuItems: [{
						name: '图谱视图',
						path: '/index',
						exact: true // 首页需要精确匹配 
					},
					{
						name: '知识管理',
						path: '/knowled-management'
					},
					{
						name: '图谱管理',
						path: '/graph-management'
					},
				],
				showMenu: false,
				isLogin: false,
				userData: null,
			}
		},
		computed: {
			tokenBalance() {
				return this.$store.state.tokenBalance;
			}
			// userName() {
			//     return this.userData
			// },

			// userPhone() {
			//     const phone = this.userData?.user?.phonenumber
			//     if (phone && phone.length === 11) {
			//         // 格式化手机号：138****1234
			//         return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
			//     }
			//     return phone || '未绑定手机号'
			// }
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll);
			// 初始化登录状态
			this.checkLoginStatus()

			// 添加全局点击事件监听
			document.addEventListener('click', this.handleClickOutside)

			// 监听storage变化（用于多标签页同步）
			window.addEventListener('storage', this.handleStorageChange)
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll);
			// 清理事件监听
			document.removeEventListener('click', this.handleClickOutside)
			window.removeEventListener('storage', this.handleStorageChange)
		},
		methods: {
			handleScroll() {
				const scrollY = window.scrollY;
				this.isScrolled = scrollY > 50;
				this.showOrgBar = scrollY <= 50;
			},
			handleRechare(url) {
				this.showMenu = false
				this.$router.push({
					path: url,
				});
			},
			// 检查登录状态
			checkLoginStatus() {
				try {
					const currentUser = sessionStorage.getItem('currentUser')
					if (currentUser) {
						this.userData = JSON.parse(currentUser)
						this.isLogin = true
						console.log('用户已登录:', this.userData)
					} else {
						this.isLogin = false
						this.userData = null
					}
				} catch (error) {
					console.error('解析用户数据失败:', error)
					this.isLogin = false
					this.userData = null
				}
			},

			// 处理storage变化
			handleStorageChange(e) {
				if (e.key === 'currentUser') {
					this.checkLoginStatus()
				}
			},

			// 点击头像
			handleClick(event) {
				event.stopPropagation()

				if (this.isLogin) {
					this.showMenu = !this.showMenu
				} else {
					// 未登录跳转到登录页
					this.$router.push('/')
				}
			},

			// 点击外部关闭菜单
			handleClickOutside(event) {
				if (this.showMenu && !this.$el.contains(event.target)) {
					this.showMenu = false
				}
			},

			// 退出登录
			async handleLogout() {
				try {
					await this.$confirm('确定要退出登录吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})

					// 清除登录信息
					sessionStorage.removeItem('currentUser')
					// 清除 Vuex store 中的用户信息
					this.$store.commit('SET_USER', null)

					// 更新状态
					this.isLogin = false
					this.userData = null
					this.showMenu = false

					// 提示用户
					this.$message.success('已退出登录')

					// 如果当前页面需要登录权限，跳转到首页
					if (this.$route.meta?.requiresAuth) {
						this.$router.push('/')
					}
				} catch (error) {
					// 用户取消操作或出错
					if (error !== 'cancel') {
						console.error('退出登录失败:', error)
						this.$message.error('退出登录失败')
					}
				}
			}
		}
	}
</script>

<style>
	/* 牵头单位信息条 */
	.leading-org-bar {
		background: linear-gradient(135deg, var(--primary-blue), var(--secondary-blue));
		color: white;
		padding: 12px 0;
		text-align: center;
		font-size: 14px;
		font-weight: 500;
		position: relative;
		z-index: 1001;
	}

	.leading-org-container {
		max-width: 1400px;
		margin: 0 auto;
		padding: 0 40px;
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 40px;
		flex-wrap: wrap;
	}

	.org-item {
		display: flex;
		align-items: center;
		gap: 8px;
		opacity: 0.95;
	}

	.org-icon {
		width: 20px;
		height: 20px;
		background: rgba(255, 255, 255, 0.2);
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 12px;
		font-weight: bold;
	}

	/* 导航栏 */
	.navbar {
		background: var(--white);
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
		position: fixed;
		width: 100%;
		top: 0px;
		z-index: 1000;
		transition: all 0.3s ease;
	}

	.navbar.scrolled {
		background: rgba(255, 255, 255, 0.95);
		backdrop-filter: blur(10px);
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
		top: 0;
	}

	.nav-container {
		max-width: 1400px;
		margin: 0 auto;
		padding: 0 40px;
		height: 80px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.logo {
		display: flex;
		align-items: center;
		gap: 12px;
		font-size: 24px;
		font-weight: 800;
	}

	.logo-icon {
		width: 48px;
		height: 48px;
		background: linear-gradient(135deg, var(--primary) 0%, var(--secondary) 100%);
		border-radius: var(--radius-sm);
		display: flex;
		align-items: center;
		justify-content: center;
		color: white;
		font-size: 20px;
	}

	.logo-text {
		background: linear-gradient(135deg, var(--primary) 0%, var(--secondary) 100%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		background-clip: text;
	}

	.version-badge {
		background: linear-gradient(135deg, var(--success) 0%, var(--secondary) 100%);
		color: white;
		padding: 4px 12px;
		border-radius: 100px;
		font-size: 12px;
		font-weight: 700;
	}

	.nav-menu {
		display: flex;
		align-items: center;
		gap: 40px;
	}

	.nav-link {
		padding: 8px 16px;
		background: none;
		border: none;
		border-radius: var(--radius-sm);
		font-size: 16px;
		font-weight: 600;
		color: var(--text-secondary);
		cursor: pointer;
		transition: var(--transition-base);
	}

	.nav-link::after {
		/* content: '';
		position: absolute;
		bottom: -5px;
		left: 0;
		width: 0;
		height: 2px;
		background: var(--primary-blue);
		transition: width 0.3s; */
	}

	.nav-link:hover {
		color: var(--primary);
		background: rgba(46, 92, 230, 0.15);
	}

	.nav-link:hover::after,
	.nav-link.active::after {
		width: 100%;
	}

	.nav-link.router-link-active {
		color: var(--primary);
		background: rgba(46, 92, 230, 0.15);
	}

	.nav-link.router-link-active::after {
		width: 100%;
	}

	.nav-actions {
		display: flex;
		align-items: center;
		gap: 20px;
	}

	.login-btn {
		padding: 10px 24px;
		background: transparent;
		border: 2px solid var(--primary-blue);
		color: var(--primary-blue);
		border-radius: 8px;
		font-weight: 500;
		cursor: pointer;
		transition: all 0.3s;
	}

	.login-btn:hover {
		background: var(--primary-blue);
		color: white;
	}

	/* 用户信息下拉菜单 */
	.user-info {
		position: relative;
	}

	.user-header {
		display: flex;
		align-items: center;
		gap: 15px;
		padding: 8px 20px;
		background: var(--light-blue);
		border-radius: 25px;
		cursor: pointer;
		transition: all 0.3s;
	}

	.user-header:hover {
		background: linear-gradient(135deg, var(--primary), var(--secondary));
		color: white;
	}

	.user-avatar {
		width: 36px;
		height: 36px;
		border-radius: 50%;
		background: var(--secondary);
		color: white;
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: 600;
	}

	.user-name {
		font-weight: 500;
	}

	.ff-coins {
		display: flex;
		align-items: center;
		gap: 5px;
		padding: 5px 12px;
		background: rgba(255, 193, 7, 0.1);
		border-radius: 15px;
		color: #f57c00;
		font-weight: 600;
	}

	.ff-icon {
		width: 20px;
		height: 20px;
		background: linear-gradient(135deg, #ffc107, #ff9800);
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		color: white;
		font-size: 12px;
		font-weight: bold;
	}

	.user-dropdown {
		position: absolute;
		top: 100%;
		right: 0;
		margin-top: 10px;
		background: white;
		border-radius: 12px;
		box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
		min-width: 200px;
		/* display: none; */
		overflow: hidden;
	}

	.user-info:hover .user-dropdown {
		/* display: block; */
	}

	.dropdown-item {
		padding: 12px 20px;
		color: var(--text-dark);
		text-decoration: none;
		display: block;
		transition: background 0.3s;
		cursor: pointer;
	}

	.dropdown-item:hover {
		background: var(--light-blue);
	}

	.dropdown-divider {
		height: 1px;
		background: var(--gray-border);
		margin: 5px 0;
	}

	/* 响应式 */
	@media (max-width: 768px) {
		.leading-org-container {
			flex-direction: column;
			gap: 15px;
			padding: 0 20px;
		}

		.leading-org-bar {
			padding: 15px 0;
		}

		.navbar {
			top: 58px;
		}

		.nav-menu {
			display: none;
		}

		.org-item {
			font-size: 13px;
		}

		.logo-text {
			font-size: 16px;
		}

		.nav-container {
			padding: 0 20px;
		}
	}
</style>